/* unplugin-vue-components disabled */import { render } from "./integralSignIn.vue?vue&type=template&id=5148a894"
import script from "./integralSignIn.vue?vue&type=script&lang=js"
export * from "./integralSignIn.vue?vue&type=script&lang=js"

import "./integralSignIn.vue?vue&type=style&index=0&id=5148a894&lang=less"
script.render = render

export default script